import React from 'react';
import { FinanceContainer } from './styles/FinanceRethink.styles';
import { PriceInformationRethink } from './PriceInformationRethink';
export const FinanceRethink = ({ isPLP, vehicleBasic, vehicle, dynamicFinancingValues, updateDynamicFinancingValues, }) => {
    return (React.createElement(FinanceContainer, { isPLP: isPLP },
        React.createElement(PriceInformationRethink, { isPLP: isPLP, vehicle: vehicle, vehicleBasic: vehicleBasic, dynamicFinancingValues: dynamicFinancingValues, updateDynamicFinancingValues: updateDynamicFinancingValues })));
};
